import { render } from "./passed_term.vue?vue&type=template&id=77c1f2ba"
import script from "./passed_term.vue?vue&type=script&lang=js"
export * from "./passed_term.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__